"use client";

import { useContext } from "react";

import { analyticsContext } from "../lib";

export const useAnalyticsContext = () => useContext(analyticsContext);
